import {useDispatch, useSelector} from "react-redux";
import InputComponent from "../../../components/input.component";
import React from "react";
import {setMainPageBestSellerDetail} from "../../../reducers/main-page.reducer";

const BestSellerProductForm = ({fieldList}) => {
    const dispatch = useDispatch()
    const {bestSellerDetail, mainPageErrorMessage} = useSelector(state => state.mainPageReducer)

    const onChangeInput = (key, value, id) => {
        let deleteList = bestSellerDetail?.delete_product || []
        dispatch(setMainPageBestSellerDetail({[key]: value, delete_product: [...deleteList, id]}))
    }

    const onChangeProduct = (key, value) => {
        let deleteList = bestSellerDetail?.delete_product?.filter(item => item !== value?.id)
        let currentProduct = bestSellerDetail.select_product
        dispatch(setMainPageBestSellerDetail({[key]: currentProduct.concat(value), delete_product: deleteList || []}))
    }

    return (
        <InputComponent item={fieldList} data={bestSellerDetail[fieldList.key]} onChange={onChangeInput} onChangeProduct={onChangeProduct} error={mainPageErrorMessage}/>
    )
}

export default BestSellerProductForm